// import React from "react";
import { Route, Routes } from "react-router-dom";
import BusinessThreeNavbar from "../../business/businessThree/businessThreeComponents/BusinessThreeNavbar";
import Navbar from "../../../default-components/Navbar";
import GlobalRoute from "../../../global route/GlobalRoute";
import { useDocument } from "../../../firebase-files/hooks/useDocument";
import FinanceHome from "../financePages/FinanceHome";

const BlackberryRoute = () => {
  const { document: navTypeDoc } = useDocument("settings", "navbarType");
  return (
    <>
      {navTypeDoc && navTypeDoc.activeNav == "FixNav" ? (
        <Navbar />
      ) : (
        <BusinessThreeNavbar />
      )}
      <Routes>
        <Route path="/" element={<FinanceHome />} />
      </Routes>
      <GlobalRoute />
    </>
  );
};

export default BlackberryRoute;
